"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurfaceWater$ = exports.SurfaceWater$outboundSchema = exports.SurfaceWater$inboundSchema = void 0;
exports.surfaceWaterToJSON = surfaceWaterToJSON;
exports.surfaceWaterFromJSON = surfaceWaterFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const meta_js_1 = require("./meta.js");
const risk_js_1 = require("./risk.js");
/** @internal */
exports.SurfaceWater$inboundSchema = z.object({
    meta: z.nullable(meta_js_1.Meta$inboundSchema),
    risk: risk_js_1.Risk$inboundSchema,
    risk_interpretation: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "risk_interpretation": "riskInterpretation",
    });
});
/** @internal */
exports.SurfaceWater$outboundSchema = z.object({
    meta: z.nullable(meta_js_1.Meta$outboundSchema),
    risk: risk_js_1.Risk$outboundSchema,
    riskInterpretation: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        riskInterpretation: "risk_interpretation",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var SurfaceWater$;
(function (SurfaceWater$) {
    /** @deprecated use `SurfaceWater$inboundSchema` instead. */
    SurfaceWater$.inboundSchema = exports.SurfaceWater$inboundSchema;
    /** @deprecated use `SurfaceWater$outboundSchema` instead. */
    SurfaceWater$.outboundSchema = exports.SurfaceWater$outboundSchema;
})(SurfaceWater$ || (exports.SurfaceWater$ = SurfaceWater$ = {}));
function surfaceWaterToJSON(surfaceWater) {
    return JSON.stringify(exports.SurfaceWater$outboundSchema.parse(surfaceWater));
}
function surfaceWaterFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.SurfaceWater$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'SurfaceWater' from JSON`);
}
//# sourceMappingURL=surfacewater.js.map